/**
 * Returns a sorting by property function for an array of objects.
 * @param property The property to sort.
 * @param asc Should the order be ascent.
 * @return {Function} The sort function.
 */
export default function sorter(property, asc = true) {
  return function(a, b) {
    if (a[property] < b[property]) return asc ? -1 : 1;
    if (a[property] > b[property]) return asc ? 1 : -1;
    return 0;
  };
}
